var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#5200FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8051 6.19526C16.0654 6.45561 16.0654 6.87772 15.8051 7.13807L9.1384 13.8047C8.87805 14.0651 8.45594 14.0651 8.19559 13.8047L4.86225 10.4714C4.6019 10.2111 4.6019 9.78894 4.86225 9.5286C5.1226 9.26825 5.54471 9.26825 5.80506 9.5286L8.66699 12.3905L14.8623 6.19526C15.1226 5.93491 15.5447 5.93491 15.8051 6.19526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.01c8df55fa90ca5e359c4b3989fcacc0.svg";
export { ForwardRef as ReactComponent };